import { formatDate } from "_helper/utils";
import { FORM_ERROR_MESSAGES } from "Constant";
import { TableColumn } from "react-data-table-component";
import { UseFormReturn } from "react-hook-form";
import { Badge } from "reactstrap";

export enum TRANG_THAI {
  HOAN_THANH = 0,
  DANG_XU_LY = 1,
}

export const TRANG_THAI_VALUES = {
  0: "Hoàn thành",
  1: "Đang xử lý",
};

export const useListTableColumns = () => {
  const tableColumns: TableColumn<any>[] = [
    {
      name: "Loại vi phạm",
      selector: ({ cccd }) => cccd || "",
    },
    {
      name: "Ngày giờ",
      selector: ({ ngaySinh }) => formatDate(ngaySinh),
    },
    {
      name: "Trạng thái",
      selector: ({ trangThai }) => (
        <Badge
          color={trangThai === TRANG_THAI.HOAN_THANH ? "success" : "danger"}
        >
          {TRANG_THAI_VALUES[trangThai]}
        </Badge>
      ),
    },
    {
      name: "Thời gian tạo",
      selector: ({ thoiGianTao }) => formatDate(thoiGianTao),
    },
    {
      name: "Người tạo",
      selector: (row) => row.nguoiTao,
    },
    {
      name: "Người chỉnh sửa",
      selector: (row) => row.nguoiChinhSua,
    },
  ];
  return { tableColumns };
};

export const useFormFields = (useFormReturn?: UseFormReturn) => {
  return [
    {
      name: "cccd",
      label: "Loại vi phạm",
      type: "input",
      rules: {
        required: FORM_ERROR_MESSAGES.REQUIRED,
      },
    },
    {
      name: "trangThai",
      label: "Trạng thái",
      type: "input",
      rules: {
        required: FORM_ERROR_MESSAGES.REQUIRED,
      },
    },
    {
      name: "nguoiTao",
      label: "Người tạo",
      type: "input",
      rules: {
        required: FORM_ERROR_MESSAGES.REQUIRED,
      },
    },
    {
      name: "nguoiChinhSua",
      label: "Người chỉnh sửa",
      type: "input",
      rules: {
        required: FORM_ERROR_MESSAGES.REQUIRED,
      },
    },
  ].flat() as any;
};

export const loaiViPhams = [
  {
    text: "lĩnh vực giáo dục",
    value: "lĩnh vực giáo dục",
  },
  {
    text: "lĩnh vực đất đai",
    value: "lĩnh vực đất đai",
  },
  {
    text: "lĩnh vực quản lý, sử dụng tài sản công",
    value: "lĩnh vực quản lý, sử dụng tài sản công",
  },
  {
    text: "lĩnh vực quản lý, bảo vệ biên giới quốc gia",
    value: "lĩnh vực quản lý, bảo vệ biên giới quốc gia",
  },
  {
    text: "lĩnh vực bổ trợ tư pháp; hành chính tư pháp; hôn nhân và gia đình; thi hành án dân sự; phá sản doanh nghiệp, hợp tác xã",
    value:
      "lĩnh vực bổ trợ tư pháp; hành chính tư pháp; hôn nhân và gia đình; thi hành án dân sự; phá sản doanh nghiệp, hợp tác xã",
  },
  {
    text: "lĩnh vực bình đẳng giới",
    value: "lĩnh vực bình đẳng giới",
  },
  {
    text: "lĩnh vực an ninh trật tự, an toàn xã hội, chống tệ nạn xã hội, phòng cháy và chữa cháy, phòng chống bạo lực gia đình",
    value:
      "lĩnh vực an ninh trật tự, an toàn xã hội, chống tệ nạn xã hội, phòng cháy và chữa cháy, phòng chống bạo lực gia đình",
  },
  {
    text: "hoạt động đầu tư xây dựng; khai thác, chế biến, kinh doanh khoáng sản làm vật liệu xây dựng, sản xuất, kinh doanh vật liệu xây dựng; quản lý công trình hạ tầng kỹ thuật; kinh doanh bất động sản, phát triển nhà ở, quản lý sử dụng nhà và công sở",
    value:
      "hoạt động đầu tư xây dựng; khai thác, chế biến, kinh doanh khoáng sản làm vật liệu xây dựng, sản xuất, kinh doanh vật liệu xây dựng; quản lý công trình hạ tầng kỹ thuật; kinh doanh bất động sản, phát triển nhà ở, quản lý sử dụng nhà và công sở",
  },
  {
    text: "lĩnh vực bưu chính, viễn thông, tần số vô tuyến điện, công nghệ thông tin và giao dịch điện tử",
    value:
      "lĩnh vực bưu chính, viễn thông, tần số vô tuyến điện, công nghệ thông tin và giao dịch điện tử",
  },
  {
    text: "lĩnh vực an toàn thực phẩm",
    value: "lĩnh vực an toàn thực phẩm",
  },
  {
    text: "lĩnh vực y tế",
    value: "lĩnh vực y tế",
  },
];

export const title = "Danh Sách theo dõi vi phạm";
export const parent = "Theo dõi vi phạm";
